import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FiArrowUpRight } from 'react-icons/fi';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './About.scss';

const About = () => {
  const [abouts, setAbouts] = useState([]);
  const [error, setError] = useState('');
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    const query = '*[_type == "abouts"] | order(_createdAt asc)';

    client.fetch(query)
      .then(setAbouts)
      .catch(() => setError('Profile details could not be loaded right now.'));
  }, []);

  return (
    <>
      <div className="section-heading">
        <div>
          <p className="eyebrow">01 / Profile</p>
          <h2 className="head-text">Where engineering practice meets <span>research curiosity.</span></h2>
        </div>
        <div>
          <p className="section-heading__copy">
            Four years of professional software engineering and a foundation in
            peer-reviewed computer vision research shape how I solve problems.
          </p>
          <a
            href="/CV_MdAminulIslam.pdf"
            target="_blank"
            rel="noreferrer"
            className="about-cv-link"
          >
            View academic CV <FiArrowUpRight />
          </a>
        </div>
      </div>

      {error && <p className="status-message status-message--error" role="status">{error}</p>}

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.article
            initial={reduceMotion ? false : { opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.55, delay: reduceMotion ? 0 : index * 0.07 }}
            className="app__profile-item"
            key={about._id || about.title}
          >
            <div className="app__profile-image">
              {about.imgUrl && (
                <img
                  src={urlFor(about.imgUrl).width(680).height(520).fit('crop').auto('format').url()}
                  alt={about.title || 'Area of expertise'}
                  loading="lazy"
                />
              )}
              <span>0{index + 1}</span>
            </div>
            <h3>{about.title}</h3>
            {about.description && <p>{about.description}</p>}
          </motion.article>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);
